import {SimpleRecord} from "../PA.Core/Basic/SimpleRecord";

export interface IEDLPAnalysis {

  Elasticity: number,

  Baseline: IEDLPAnalysisPeriod,
  PriceChange: IEDLPAnalysisPeriod

}


export interface IEDLPAnalysisPeriod {

  CnsStartDt: Date,
  CnsEndDt: Date,

  ListPrice: number,
  EDLPSpend: number,
  EDLPSpendVolBasis: number,
  EDLPSpendRateOvrd: number,
  NetEDLPListPrice: number,

  BasePrice: number,
  NonPromotedPrice: number,
  ActualEveryDayMarginPcnt: number,


  // Re Calculate either of these if List Price changes
  TrueBasePriceOvrd: number,
  RetailerMarginOvrd: number,

  SubsidizationPcnt: number,

  EDLPLiftPcnt: number,

  WeekCount: number,

  SyndBaseUnits: number,
  SyndBaseWt:    number,
  SyndBaseProfit: number,

  TrueBaseUnits: number,
  TrueBaseWt:    number,
  TrueBaseProfit: number,


  EDLPUnits: number,
  EDLPWt: number,
  EDLPProfit: number,
  EDLPROI: number

}


export class EDLPAnalysisRow
  extends  SimpleRecord
  implements IEDLPAnalysis {

  constructor() {
    super()

    this._Baseline = new EDLPAnalysisPeroidRow();
    this._PriceChange = new EDLPAnalysisPeroidRow();

  }


  _CnsStartDt: Date = undefined;
  _CnsEndDt: Date = undefined;

  _Elasticity: number = -1;
  _Baseline: EDLPAnalysisPeroidRow;
  _PriceChange: EDLPAnalysisPeroidRow;

  _TrueBaseCalcMethod: string = "Ovrd"

  get Baseline(): EDLPAnalysisPeroidRow {
    return this._Baseline
  }

  get PriceChange(): EDLPAnalysisPeroidRow {
    return this._PriceChange
  }


  get Elasticity(): number {
    return this._Elasticity
  }
  set Elasticity(value: number) {
    this._Elasticity = value
    this.notify('Elasticity', value)
  }

  get TrueBaseCalcMethod(): string {
    return this._TrueBaseCalcMethod
  }
  set TrueBaseCalcMethod(value: string) {
    this._TrueBaseCalcMethod = value
    this.notify('TrueBaseCalcMethod', value)
  }

}

export class EDLPAnalysisPeroidRow
  extends  SimpleRecord
  implements IEDLPAnalysisPeriod
{

  _CnsStartDt: Date = undefined;
  _CnsEndDt: Date = undefined;

  _ListPrice: number = 0;
  _EDLPSpend: number = 0;
  _EDLPSpendVolBasis: number = 0;
  _EDLPSpendRateOvrd: number = 0;
  _NetEDLPListPrice: number = 0;

  _BasePrice: number = 0;
  _NonPromotedPrice: number = 0;
  _ActualEveryDayMarginPcnt: number = 0;


  // Re Calculate either of these if List Price changes
  _TrueBasePriceOvrd: number  = 0;
  _RetailerMarginOvrd: number = 0;

  _SubsidizationPcnt: number = 0;

  _EDLPLiftPcnt: number = 0;

  _WeekCount: number = 0;

  _SyndBaseUnits: number = 0;
  _SyndBaseWt:    number = 0;
  _SyndBaseProfit: number = 0;

  _TrueBaseUnits: number = 0;
  _TrueBaseWt:    number = 0;
  _TrueBaseProfit: number = 0;


  _EDLPUnits: number = 0;
  _EDLPWt: number = 0;
  _EDLPProfit: number = 0;
  _EDLPROI: number = 0;

  constructor() {
    super()

  }

  get CnsStartDt(): Date {
    return this._CnsStartDt
  }
  set CnsStartDt(value: Date) {
    this._CnsStartDt = value
    this.notify('CnsStartDt', value)
  }

  get CnsEndDt(): Date {
    return this._CnsEndDt
  }
  set CnsEndDt(value: Date) {
    this._CnsEndDt = value
    this.notify('CnsEndDt', value)
  }

  get ListPrice(): number {
    return this._ListPrice
  }
  set ListPrice(value: number) {
    this._ListPrice = value
    this.notify('ListPrice', value)
  }


  get EDLPSpend(): number {
    return this._EDLPSpend
  }
  set EDLPSpend(value: number) {
    this._EDLPSpend = value
    this.notify('EDLPSpend', value)
  }


  get EDLPSpendVolBasis(): number {
    return this._EDLPSpendVolBasis
  }
  set EDLPSpendVolBasis(value: number) {
    this._EDLPSpendVolBasis = value
    this.notify('EDLPSpendVolBasis', value)
  }



  get EDLPSpendRateOvrd(): number {
    return this._EDLPSpendRateOvrd
  }
  set EDLPSpendRateOvrd(value: number) {
    this._EDLPSpendRateOvrd = value
    this.notify('EDLPSpendRateOvrd', value)
  }


  get NetEDLPListPrice(): number {
    return this._NetEDLPListPrice
  }
  set NetEDLPListPrice(value: number) {
    this._NetEDLPListPrice = value
    this.notify('NetEDLPListPrice', value)
  }


  get BasePrice(): number {
    return this._BasePrice
  }
  set BasePrice(value: number) {
    this._BasePrice = value
    this.notify('BasePrice', value)
  }



  get NonPromotedPrice(): number {
    return this._NonPromotedPrice
  }
  set NonPromotedPrice(value: number) {
    this._NonPromotedPrice = value
    this.notify('NonPromotedPrice', value)
  }


  get ActualEveryDayMarginPcnt(): number {
    return this._ActualEveryDayMarginPcnt
  }
  set ActualEveryDayMarginPcnt(value: number) {
    this._ActualEveryDayMarginPcnt = value
    this.notify('ActualEveryDayMarginPcnt', value)
  }


  get TrueBasePriceOvrd(): number {
    return this._TrueBasePriceOvrd
  }
  set TrueBasePriceOvrd(value: number) {
    this._TrueBasePriceOvrd = value
    this.notify('TrueBasePriceOvrd', value)
  }


  get RetailerMarginOvrd(): number {
    return this._RetailerMarginOvrd
  }
  set RetailerMarginOvrd(value: number) {
    this._RetailerMarginOvrd = value
    this.notify('RetailerMarginOvrd', value)
  }


  get SubsidizationPcnt(): number {
    return this._SubsidizationPcnt
  }
  set SubsidizationPcnt(value: number) {
    this._SubsidizationPcnt = value
    this.notify('SubsidizationPcnt', value)
  }


  get EDLPLiftPcnt(): number {
    return this._EDLPLiftPcnt
  }
  set EDLPLiftPcnt(value: number) {
    this._EDLPLiftPcnt = value
    this.notify('EDLPLiftPcnt', value)
  }


  get WeekCount(): number {
    return this._WeekCount
  }
  set WeekCount(value: number) {
    this._WeekCount = value
    this.notify('WeekCount', value)
  }


  get SyndBaseUnits(): number {
    return this._SyndBaseUnits
  }
  set SyndBaseUnits(value: number) {
    this._SyndBaseUnits = value
    this.notify('SyndBaseUnits', value)
  }


  get SyndBaseWt(): number {
    return this._SyndBaseWt
  }
  set SyndBaseWt(value: number) {
    this._SyndBaseWt = value
    this.notify('SyndBaseWt', value)
  }


  get SyndBaseProfit(): number {
    return this._SyndBaseProfit
  }
  set SyndBaseProfit(value: number) {
    this._SyndBaseProfit = value
    this.notify('SyndBaseProfit', value)
  }


  get TrueBaseUnits(): number {
    return this._TrueBaseUnits
  }
  set TrueBaseUnits(value: number) {
    this._TrueBaseUnits = value
    this.notify('TrueBaseUnits', value)
  }


  get TrueBaseWt(): number {
    return this._TrueBaseWt
  }
  set TrueBaseWt(value: number) {
    this._TrueBaseWt = value
    this.notify('TrueBaseWt', value)
  }


  get TrueBaseProfit(): number {
    return this._TrueBaseProfit
  }
  set TrueBaseProfit(value: number) {
    this._TrueBaseProfit = value
    this.notify('TrueBaseProfit', value)
  }


  get EDLPUnits(): number {
    return this._EDLPUnits
  }
  set EDLPUnits(value: number) {
    this._EDLPUnits = value
    this.notify('EDLPUnits', value)
  }


  get EDLPWt(): number {
    return this._EDLPWt
  }
  set EDLPWt(value: number) {
    this._EDLPWt = value
    this.notify('EDLPWt', value)
  }


  get EDLPProfit(): number {
    return this._EDLPProfit
  }
  set EDLPProfit(value: number) {
    this._EDLPProfit = value
    this.notify('EDLPProfit', value)
  }


  get EDLPROI(): number {
    return this._EDLPROI
  }
  set EDLPROI(value: number) {
    this._EDLPROI = value
    this.notify('EDLPROI', value)
  }


}

